export default __webpack_public_path__ + "static/media/user.191fe8f3.jpg";